import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSearchParams } from 'react-router-dom';
import { useMemoizedFn } from 'ahooks';
import { find } from 'lodash';
import { connect } from 'react-redux';
import { getClusterInfo } from '@/services/codeSamplesService';
import ListPanel from '@/components/ListPanel';
import { doBuried } from '@/services/buriedService';
import { isVoid } from '@/utils/common';
import NoData from '@/components/NoData';
import { fetchCodeExampleUrl } from '@/slices/codeSampleSlice';
import Markdown from '../components/Markdown';
import JavaPng from './images/java.png';
import PythonPng from './images/Python.png';
import SpringBootPng from './images/SpringBoot.png';
import CPng from './images/c++.png';
import CsharpPng from './images/csharp.png';
import GolangPng from './images/Golang.png';
import Brief from './Brief';
import Article from './Article';
import LanguageSwitch from './LanguageSwitch';

function CodeSamples({ fetchCodeExampleUrl }) {
  const [searchParams] = useSearchParams();
  const [currentTag, setCurrentTag] = useState('Java');
  const [brokerServiceUrl, setBrokerServiceUrl] = useState('');

  const clusterName = searchParams.get('name');

  const loadData = useMemoizedFn(async () => {
    const { data } = await getClusterInfo(clusterName);
    if (data.brokerServiceUrl) {
      setBrokerServiceUrl(data.brokerServiceUrl);
    }
  });

  useEffect(() => {
    if (clusterName) {
      loadData();
      fetchCodeExampleUrl();
    }
  }, [loadData, clusterName, fetchCodeExampleUrl]);

  const options = [
    {
      value: 'Java',
      label: 'Java',
      img: JavaPng,
      eventId: 'DEV_JAVA_CLIENT',
    },
    {
      value: 'Python',
      label: 'Python',
      img: PythonPng,
      eventId: 'DEV_PYTHON_CLIENT',
    },
    {
      value: 'Golang',
      label: 'Golang',
      img: GolangPng,
      eventId: 'DEV_GOLANG_CLIENT',
    },
    {
      value: 'C++',
      label: 'C++',
      img: CPng,
      eventId: 'DEV_CPP_CLIENT',
    },
    {
      value: 'C#',
      label: 'C#',
      img: CsharpPng,
      eventId: 'DEV_CSHARP_CLIENT',
    },
    {
      value: 'Spring Boot',
      label: 'Spring Boot',
      img: SpringBootPng,
      eventId: 'DEV_SPRING_BOOT_CLIENT',
    },
  ];
  const onChange = (val) => {
    setCurrentTag(val);
    const { eventId } = find(options, { value: val });
    doBuried({
      eventId,
    });
  };

  const content = `
### 您可以通过以下几种客户端连接您的集群
Pulsar支持多种语言的客户端，详细使用方式可以参考 [官方文档](https://pulsar.apache.org/docs/3.2.x/client-libraries/)；
如果集群开启了JWT认证，需要配置 **YOUR_PULSAR_TOKEN**，请 [前往](/cluster/permissions/roles?name=${clusterName})
  `;

  return isVoid(clusterName) ? (
    <NoData style={{ marginTop: 100 }} tip='暂无集群，请先部署' />
  ) : (
    <ListPanel header='代码示例'>
      <Markdown content={content} />
      <LanguageSwitch option={options} currentTag={currentTag} onChange={onChange} />
      <Body>
        <Brief currentTag={currentTag} clusterName={clusterName} />
        <Article currentTag={currentTag} brokerServiceUrl={brokerServiceUrl} />
      </Body>
    </ListPanel>
  );
}

export default connect(null, {
  fetchCodeExampleUrl,
})(CodeSamples);

const Body = styled.div`
  margin-top: 50px;
`;
